import {ElementRef, Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class TutorialHighlightService {

  private _visible: boolean;
  public get visible(): boolean {
    return this._visible;
  }

  private _element: HTMLElement;
  public get element(): HTMLElement {
    return this._element;
  }

  constructor() {

  }

  show(element: HTMLElement | ElementRef<HTMLElement>) {
    this._element = (element as unknown as ElementRef<HTMLElement>)?.nativeElement ? (element as unknown as ElementRef<HTMLElement>)?.nativeElement : element as HTMLElement;
    this._visible = this._element?.getBoundingClientRect ? true : false;
  }

  hide() {
    this._visible = false;
    this._element = null;
  }

}
